import React from 'react';


export const LoadingSpinner = ({message}) => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="glass-card p-8 text-center max-w-md mx-auto">
      <div className="relative w-12 h-12 mx-auto mb-4">
        <div className="absolute inset-0 rounded-full border-4 border-worldsview-purple/20"></div>
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-worldsview-purple animate-spin"></div>
      </div>
      <p className="text-muted-foreground">Loading content...</p>
      <p className="text-xs text-muted-foreground/70 mt-2">{message ? message : `Please wait`}</p>
    </div>
  </div>
);